import { mapRecordingError, RecordingErrorCode } from "@speakai/common/src/recorder/core/errors/recording-errors";

const RECORDING_ERROR_MESSAGES: Record<RecordingErrorCode, string | null> = {
  [RecordingErrorCode.DeviceNotFound]: "Required media device not found. Please ensure your microphone and camera are connected and try again.",
  [RecordingErrorCode.PermissionDenied]: "Permission to access media devices was denied. Please allow microphone and camera access in your browser settings and try again.",
  [RecordingErrorCode.OverConstrained]: "Media device does not support the requested constraints. Please try with different settings.",
  [RecordingErrorCode.UserCancelled]: null,
  [RecordingErrorCode.Aborted]: "Media access was aborted. Please try again.",
  [RecordingErrorCode.DeviceInUse]: "Media device is already in use or a hardware error occurred. Please try again.",
  [RecordingErrorCode.InsecureContext]: "Security error accessing media devices. Please ensure you are on a secure connection (HTTPS).",
  [RecordingErrorCode.NotSupported]: "Screen capture is not supported in this browser. Please use a modern browser.",
  [RecordingErrorCode.Unknown]: "We are having trouble capturing the recording from this device. Please try another browser or device.",
};

/**
 * Maps DOMException error names from getUserMedia / getDisplayMedia to user-facing strings.
 * Returns null for screen-mode AbortError (user dismissed picker) — caller suppresses the banner.
 * TODO: copy review — all error strings below are pending Product review before merging to dev.
 */
export function getRecordingErrorMessage(
  err: unknown,
  _isVideo = false, // reserved for mode-aware copy once Product review completes
  mode?: "audio" | "video" | "screen",
): string | null {
  if (!(err instanceof DOMException)) {
    return "Failed to access media devices. Please check permissions and try again.";
  }
  return RECORDING_ERROR_MESSAGES[mapRecordingError(err, { mode })];
}
